import { Model, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import StaticCurrencyLookup from '../../Models/StaticCurrencyLookup';
import { AppService } from '../../../App/Services/AppService';
import { StaticDataTypes } from '../../../Maintenance/StaticData/StaticDataTypes';

@NeoModel
export default class CurrencyComponentVM extends Views.ViewModelBase {
    constructor(
        public staticDataCache = AppService.get(StaticDataTypes.Services.StaticDataCache))
        {
            super();
        }
    public selectedCurrency = new StaticCurrencyLookup();
    public staticCurrencyLookupList: Model.PlainObject<StaticCurrencyLookup>[] = [];

    public isReadOnly: boolean = false;

    public async initialise() {
    }

    public async getCurrenciesList () {
        this.staticCurrencyLookupList = await this.staticDataCache.staticCurrencies.getDataAsync();
    }
}